export default {
  ws: {},
  setWs: function(newWs) {
    this.ws = newWs
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js